import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { TSaveLeadResponse } from './types';

type TParams = {
  httpApi: IHttpApi;
  logger: ILogger;
  userId: number;
  name: string;
  phone: string;
  email: string;
};

export const saveLeadV1Info = async ({ httpApi, userId, name, phone, email }: TParams): Promise<TSaveLeadResponse> => {
  const { statusCode, response } = await httpApi.fetch({
    apiType: 'external',
    microserviceName: 'info-api',
    assertStatusCodes: [200],
    method: 'POST',
    requestContentType: 'json',
    pathApi: '/api/hosts/v1/save-form-request',
    parameters: { userId, name, phone, email },
  });

  return { statusCode, response } as TSaveLeadResponse;
};
